import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import * as DataServices from '../services/menu';

export const useGetMenus = (PerfilId, options?) =>
  useQuery(['menus', PerfilId], () => DataServices.fetchAll({ PerfilId }), options);

export const useGetCurrentClientMenus = (filters, options?) =>
  useQuery(['currentClientMenus'], () => DataServices.fetchCurrent(filters), options);

// export const useGetAllMenusSelect = (PerfilId, options?) =>
//   useQuery(['currentMenuSelect'], () => DataServices.fetchAllMenusSelect(PerfilId || null), options);
export const useGetAllMenusSelect = (filters, options?) =>
  useQuery(['currentMenuSelect'], () => DataServices.fetchAllMenusSelect(filters), options);

export const useUpsertMenuClient = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation(([clirut: cliRut, values: Values]) => DataServices.upsertMenuClient(clirut, values), {
    onMutate: async (data) => {
      await queryClient.cancelQueries(['menuClient']);
      const previousData = queryClient.getQueryData(['menuClient']);
      // queryClient.setQueryData(['camps'], (old) => [...old.filter((x) => x.id !== data.id), data]);
      queryClient.setQueryData(['menuClient'], (old) => old);
      return { previousData };
    },
    onError: (err, data, context) => {
      console.log(err);
      queryClient.setQueryData(['menuClient'], context.previousData);
      enqueueSnackbar('Error al actualizar.', { variant: 'error' });
    },
    onSettled: () => {
      enqueueSnackbar('Actualizado', { variant: 'success' });
      queryClient.invalidateQueries(['menuClient']);
    },
  });
};
